<template>
  <div>
    <!-- デマンドヘッダー -->
    <TheDemandHeader :title="`${selectedService.name}の手配`" page="3" />

    <!-- division別支払い方法選択 -->
    <TheDemandSelectPayment v-model:seatCount="seatCount" />

    <TheDemandActionButton3
      :selected-service="selectedService"
      :seat-count="seatCount"
      :payment-methods="paymentMethods"
    />
  </div>
</template>

<script>
import { ref } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { onMounted } from "vue";

export default {
  name: "TemplateDemandBooking3",
  setup(props) {
    const store = useStore();
    const router = useRouter();

    const seatCount = store.getters["demand/seatCount"];
    const selectedService = store.getters["demand/selectedService"];
    const paymentMethods = ref([]);

    onMounted(async () => {
      for (let i = 0; i < seatCount.adult; i++) {
        paymentMethods.value.push({ adult: "free" });
      }
      for (let i = 0; i < seatCount.child; i++) {
        paymentMethods.value.push({ child: "free" });
      }
      for (let i = 0; i < seatCount.infant; i++) {
        paymentMethods.value.push({ infant: "free" });
      }
      console.log("paymentMethods :>> ", paymentMethods);
    });

    return {
      seatCount,
      paymentMethods,
      selectedService,
    };
  },
};
</script>

<style lang="scss">
@media screen and (max-width: 364px) {
  .caution {
    font-size: 10px;
    line-height: 13px;
  }
}

.payment_caution {
  color: red;
  margin: 10px 20px;
  text-align: right;
  font-size: 0.8rem;
}
</style>
